<ng-container *transloco="let t">
  <div class="account-layout-container">
    @if (isLoading()) {
      <div class="overlay-loader">
        <div class="loader"></div>
      </div>
    }
    @if (view === AccountView.Form) {
      <button type="button" vinnova-button-link (click)="setListView()">
        <lib-icon name="chevron-left" class="me-1" size="x-small"></lib-icon>
        {{ t('oreg_account_btn_back') }}
      </button>
    }
    @if (!isLoading()) {
      <div class="account-container">
        @if (view === AccountView.List) {
          <lib-account-list
            [accountList]="accountList()"
            (cancel)="cancel.emit()"
            (createAccount)="view = AccountView.Form"
            (selectAccount)="sendMessage($event)"
          ></lib-account-list>
        }
        @if (view === AccountView.Form) {
          <lib-account-form
            [accountToEdit]="accountToEdit ? accountToEdit() : undefined"
            [worksiteId]="_worksiteId"
            [companyId]="accountToEdit ? accountToEdit()?.companyId : undefined"
            (cancel)="setListView()"
            (accountSubmitted)="sendMessage($event)"
          ></lib-account-form>
        }
      </div>
    }
  </div>
</ng-container>
